export const BASE_URL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_DEV_MODE
    : process.env.REACT_APP_PRO_MODE;
export const PICTURE_URL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_DEV_MODE?.slice(0, -5)
    : process.env.REACT_APP_PRO_MODE?.slice(0, -5);
export const LOGIN_URL = BASE_URL + "auth";
export const COMPANY_URL = BASE_URL + "admin/companies";
export const USER_URL = BASE_URL + "admin/users";
export const LOCATIONS_URL = BASE_URL + "admin/locations";
export const FLOORS_URL = BASE_URL + "admin/floors";
export const FLATS_URL = BASE_URL + "admin/flats";
export const ROOMS_URL = BASE_URL + "admin/rooms";
export const CUSTOMERS_URL = BASE_URL + "admin/customers";
export const ROOM_ITEMS_URL = BASE_URL + "admin/room-items";
export const ROOM_NAMES_URL = BASE_URL + "admin/room-names/room-name";
export const MATERIALS_URL = BASE_URL + "admin/materials";
export const FLOOR_TYPE_URL = BASE_URL + "admin/floor-types";
export const MATERIAL_TYPE_URL = BASE_URL + "admin/material-types";
export const SKIRTING_BOARD_URL = BASE_URL + "admin/skirting-boards";
export const SUBSCRIPTION_URL = BASE_URL + "admin/subscriptions";
export const JOB_URL = BASE_URL + "admin/jobs";
export const TEMPLATE_INTRO_URL = BASE_URL + "admin/template-intro";
export const TEMPLATE_APPENDIX_URL = BASE_URL + "admin/template-appendix";
export const JOB_CATEGORIES_URL = BASE_URL + "admin/job-categories";
export const JOB_TARGET_GROUPS_URL = BASE_URL + "admin/job-target-groups";
export const SETTINGS_URL = BASE_URL + "admin/settings";
export const BLOG_URL = BASE_URL + "admin/blogs";
export const LOCATION_URL = BASE_URL + "admin/locations";
export const PAGE_URL = BASE_URL + "admin/pages";
export const QA_CATEGORY_URL = BASE_URL + "admin/qa/categories";
export const QA_URL = BASE_URL + "admin/qa";
export const SECTION_URL = BASE_URL + "admin/sections";
export const JOBS_URL = BASE_URL + "admin/jobs";
export const PACKAGES_URL = BASE_URL + "admin/subscriptions/packages";
export const REGIONS_URL = BASE_URL + "admin/regions";
export const QUALIFICATIONS_URL = BASE_URL + "admin/qualifications";
export const JOB_FORMATS_URL = BASE_URL + "admin/job-formats";
export const SPECIAL_CONDITION_URL = BASE_URL + "admin/special-conditions";
export const SUPPLIER_URL = BASE_URL + "admin/suppliers";
export const JOB_PACKAGE_URL = BASE_URL + "admin/job-packages";
export const DOCUMENT_TEMPLATES_URL = BASE_URL + "admin/document-templates";
export const CUSTOMER_TYPE_URL = BASE_URL + "admin/customers-types";
export const OFFER_CONDITION_NAMES_URL =
  BASE_URL + "admin/offers-condition-names";
